import { render, staticRenderFns } from "./MaterialsPage.vue?vue&type=template&id=49284ba8&scoped=true"
import script from "./MaterialsPage.vue?vue&type=script&lang=ts"
export * from "./MaterialsPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialsPage.vue?vue&type=style&index=0&id=49284ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49284ba8",
  null
  
)

export default component.exports